import React from "react"
import PusherContext from "contexts/pusher/PusherContext"

export default function PusherProvider({pusher, ...rest}) {
  return <PusherContext.Provider
      value={pusher}
      {...rest}/>
}